import { Form, useActionData, useNavigation } from 'react-router-dom';

import classes from './ChangePassword.module.css';

function ChangePassword() {
  const data = useActionData();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <>
      <Form method="post" className={classes.form}>
        <div className={classes.actions}>
        </div>
        <p>
          <label htmlFor="image">Password</label>
          <input id="password" type="password" name="password" required />
        </p>
        <p>
          <label htmlFor="image">New Password</label>
          <input id="new-password" type="password" name="new-password" required />
        </p>
        <p>
          <label htmlFor="image">Password Again</label>
          <input id="verify-password" type="password" name="verify-password" required />
        </p>
        <div className={classes.actions}>
          <button disabled={isSubmitting}>
            {isSubmitting ? 'Changing...' : 'Change'}
          </button>
        </div>
        {data && data.errors && (
          <ul>
            {Object.values(data.errors).map((error) => (
              <li className={classes.error} key={error}>{error}</li>
            ))}
          </ul>
        )}
      </Form>
    </>
  );
}

export default ChangePassword;
